<template>
  <div>
    <label-tag :tagArray="[$t('general_list'), $t('story_mode'), $t('vocabulary_mode'), $t('conversation_mode')]"  v-on:updatedScene="updatedScene" v-on:updatedMode="updatedMode" :previous="isVoices" @previousPage="isVoices=false"/>
    <div class="m-5" style="overflow: auto;">
      <!-- 總表 -->
      <table v-if="modeId === 0 && !isVoices" class="table table-borderless table-hover">
        <thead>
          <tr>
            <th>{{$t('student_id')}}</th>
            <th>{{$t('name')}}</th>
            <th>{{$t('time_used')}}</th>
            <th>({{$t('story_mode')}}){{$t('usage_time')}}</th>
            <th>({{$t('vocabulary_mode')}}){{$t('usage_time')}}</th>
            <th>({{$t('conversation_mode')}}){{$t('usage_time')}}</th>
            <th>{{$t('total_usage_time')}}</th>
          </tr>
        </thead>
        <tbody style="border-top:1px #cccccc solid;border-bottom:1px #cccccc solid;">
          <tr v-for="item in summaryList" :key="item.id">
            <td>
              {{item.studentNo}}
            </td>
            <td>
              {{item.realName}}
            </td>
            <td>
              {{item.usedCount}}
            </td>
            <td>
              {{item.plotSpendTime}}
            </td>
            <td>
              {{item.vocabSpendTime}}
            </td>
            <td>
              {{item.dialogSpendTime}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 模式 -->
      <table class="table table-borderless table-hover">
        <thead>
          <!-- 劇情 -->
          <tr v-if="modeId === 1 && !isVoices">
            <th>{{$t('student_id')}}</th>
            <th>{{$t('name')}}</th>
            <th>{{$t('date')}}</th>
            <th>{{$t('last_update_time')}}</th>
            <th>{{$t('scene')}}</th>
            <!-- <th>星數</th> -->
            <th>{{$t('score')}}</th>
            <th>{{$t('detail')}}</th>
            <th>{{$t('study_time')}}</th>
          </tr>
          <!-- 單字 -->
          <tr v-if="modeId === 2 && !isVoices">
            <th>{{$t('student_id')}}</th>
            <th>{{$t('name')}}</th>
            <th>{{$t('date')}}</th>
            <th>{{$t('last_update_time')}}</th>
            <th>{{$t('scene')}}</th>
            <th>{{$t('result')}}</th>
            <th>{{$t('words_found')}}</th>
            <th>{{$t('study_time')}}</th>
          </tr>
          <!-- 對話 -->
          <tr v-if="modeId === 3 && !isVoices">
            <th>{{$t('student_id')}}</th>
            <th>{{$t('name')}}</th>
            <th>{{$t('date')}}</th>
            <th>{{$t('last_update_time')}}</th>
            <th>{{$t('scene')}}</th>
            <th>{{$t('result')}}</th>
            <th>{{$t('score')}}</th>
            <th>{{$t('detail')}}</th>
            <th>{{$t('study_time')}}</th>
          </tr>
          <!-- 語音下載 -->
          <tr v-if="isVoices">
            <th>{{$t('student_id')}}</th>
            <th>{{$t('name')}}</th>
            <th>{{$t('dialogue')}}
              <span class="ml-3 my-auto">
                <span class="badge badge-success">很棒</span>
                <span class="badge badge-warning mx-2">尚可</span>
                <span class="badge badge-danger">待加強</span>
              </span>
            </th>
            <th>{{$t('score')}}</th>
            <th>{{$t('views')}}</th>
            <th>{{$t('play')}}</th>
            <!-- <th>{{$t('speech_image')}}</th> -->
            <th>{{$t('download')}}</th>
          </tr>
        </thead>
        <tbody v-if="!isVoices" style="border-top:1px #cccccc solid;border-bottom:1px #cccccc solid;">
          <!-- 劇情 -->
          <tr v-if="modeId === 1" v-for="item in modeList" :key="item.id">
            <td>
              {{item.studentNo}}
            </td>
            <td>
              {{item.userName}}
            </td>
            <td>
              {{item.createTime.slice(0,11)}}
            </td>
            <td>
              {{item.createTime.slice(11,200)}}
            </td>
            <td>
              {{item.situationName}}
            </td>
            <!-- <td>
              <span v-for="(el, index) in item.starCount" :key="index">★</span>
            </td> -->
            <td>
              {{item.voiceScore}}
            </td>
            <td class="link-tag pointer" @click="goVoice(item)">
              {{$t('detail')}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
          </tr>
          <!-- 單字 -->
          <tr v-if="modeId === 2" v-for="item in modeList" :key="item.id">
            <td>
              {{item.studentNo}}
            </td>
            <td>
              {{item.userName}}
            </td>
            <td>
              {{item.createTime.slice(0,11)}}
            </td>
            <td>
              {{item.createTime.slice(11,200)}}
            </td>
            <td>
              {{item.situationName}}
            </td>
            <td>
              {{item.situationName==='Practice' ? '-----' :(item.isSuccess ? $t('pass'): $t('fail')) }}
            </td>
            <td >
              {{item.foundNum}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
          </tr>
          <!-- 對話 -->
          <tr v-if="modeId === 3" v-for="item in modeList" :key="item.id">
            <td>
              {{item.studentNo}}
            </td>
            <td>
              {{item.userName}}
            </td>
            <td>
              {{item.createTime.slice(0,11)}}
            </td>
            <td>
              {{item.createTime.slice(11,200)}}
            </td>
            <td>
              {{item.situationName}}
            </td>
            <td>
              {{item.isSuccess ? $t('pass'): $t('fail')}}
            </td>
            <td>
              {{item.voiceScore}}
            </td>
            <td class="pointer link-tag" @click="goVoice(item)" v-if="modeId !== 2">
              {{$t('detail')}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
          </tr>
        </tbody>
        <!-- 語音下載 -->
        <tbody v-if="isVoices" style="border-top:1px #cccccc solid;border-bottom:1px #cccccc solid;">
          <tr v-for="(item , index) in voiceData" :key="item.id">
            <td>{{ index===0 ? studentInfo.studentNo : ''}}</td>
            <td>{{ index===0 ? studentInfo.userName : ''}}</td>
            <td style="min-width:40%;">
              <!-- {{item.text}} -->
              <span style="margin-left:.2rem;" v-for="(el , index) in item.wordScores" :class="{ 'good' : item.score>75 , 'normal' : item.score<75 &&item.score>65 ,'bad' : item.score<65}">
                {{el.text}}
              </span>
            </td>
            <td>{{Math.round(item.score)}}</td>
            <td>{{item.listenedCount}}</td>
            <td class="pointer link-tag" @click="playAudio(item.voiceUrl)">
              <a>
                {{$t('play')}}
              </a>
            </td>
            <!-- <td>
              <a class="link-tag" @click="getImage(item.voiceUrl)" href="javascript: void(0)">
                {{$t('view')}}
              </a>
            </td> -->
            <td>
              <a class="link-tag" download target="_blank" :href="item.voiceUrl">
                {{$t('download')}}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination v-if="modeId === 0 && pageCount > 1" :current="pageIndex" :total="pageCount" v-on:page="getSummaryList" />
      <pagination v-if="modeId !== 0 && modePageCount > 1" :current="modePageIndex" :total="modePageCount" v-on:page="getModeList" />
    </div>
    <audio id="audio">
      <source :src="voiceUrl" type="audio/ogg">
    </audio>
  </div>
</template>

<script>
import axios from 'axios'
import pagination from './Pagination'
import api from '../../../store/api'
import labelTag from './Label'
export default {

  name: 'Record',

  data () {
    return {
      summaryList: [],
      modeList: [],
      sceneId: null,
      modeId: 0,
      isVoices: false,
      studentInfo: null,
      voiceData: null,
      voiceUrl: '',
      pageIndex: 1,
      pageCount: 0,
      pageSize: 10,
      modePageIndex: 1,
      modePageCount: 0,
      voiceImage: ''
    }
  },
  components: {
    labelTag,
    pagination
  },
  watch: {
    sceneId (val) {
      this.getSummaryList()
      this.getModeList()
    },
    mode (val) {
      this.getSummaryList()
      this.getModeList()
    },
    voiceUrl (val) {
      this.playAudio(val)
    }
  },
  computed: {
    mode () {
      switch (this.modeId) {
        case 0:
          return null
        case 1:
          return 'Plot'
        case 2:
          return 'Vocab'
        case 3:
          return 'Dialog'
      }
    }
  },
  mounted () {
    this.getSummaryList()
  },
  methods: {
    async getSummaryList (page) {
      page = page || 1
      let userRole = this.$store.state.auth.userRole
      if (userRole === 'Teacher') {
        const groupId = this.$route.params.id
        let params = {
          sceneId: this.sceneId,
          pageIndex: page,
          pageSize: this.pageSize
        }
        const { data } = await api.get(`/VR/Record/Group/${groupId}/Students/Summary`, {params})
        this.summaryList = data.data
        this.pageCount = data.pageCount
        this.pageIndex = data.pageIndex
      } else {
        let params = {
          sceneId: this.sceneId
        }
        const { data } = await api.get(`/VR/Record/Summary`, {params})
        let array = []
        array.push(data.data)
        this.summaryList = array
      }
    },
    async getModeList (page) {
      page = page || 1
      let userRole = this.$store.state.auth.userRole
      if (this.mode !== 0) {
        if (userRole === 'Teacher') {
          const groupId = this.$route.params.id
          let params = {
            mode: this.mode,
            sceneId: this.sceneId,
            pageIndex: page,
            pageSize: this.pageSize
          }
          const { data } = await api.get(`/VR/Record/Group/${groupId}/Students`, {params})
          this.modeList = data.data
          this.modePageCount = data.pageCount
          this.modePageIndex = data.pageIndex
        } else {
          let params = {
            mode: this.mode,
            sceneId: this.sceneId,
            pageIndex: page,
            pageSize: this.pageSize
          }
          const { data } = await api.get(`/VR/Record`, {params})
          this.modeList = data.data
          this.pageCount = data.pageCount
          this.pageIndex = data.pageIndex
        }
      }
    },
    async getVoices (recordId) {
      const { data } = await api.get(`/VR/Record/${recordId}/Voices`)
      this.voiceData = data.data.map(item => {
        let words = item.text.split(' ')
        item.wordScores = words.map((word, index) => {
          return { text: word, score: item.wordScores[index] || 0 }
        })
        return item
      })

      console.log(this.voiceData)
    },
    goVoice (record) {
      this.isVoices = true
      this.studentInfo = record
      this.getVoices(record.id)
    },
    updatedScene (index) {
      this.sceneId = index
    },
    updatedMode (mode) {
      this.isVoices = false
      this.modeId = mode
    },
    playAudio (url) {
      this.voiceUrl = url
      let dom = document.getElementById('audio')
      dom.load()
      dom.play()
    },
    async getImage (url) {
      const { data } = await axios.get(`https://voicerecognition.liveabc.com/api/ERS/${url.slice(url.search('/ers/') + 5, url.search('/orgAudio')).replace('/', '_')}`)
      // console.log(url.search('/ers/'))
      // console.log(url.search('/orgAudio'))
      // console.log(url.slice(url.search('/ers/') + 5, url.search('/orgAudio')).replace('/', '_'))
      this.voiceImage = data.ImageUrl
      window.open(data.ImageUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "../../../assets/style/color.scss";
  table {
    text-align: left;
    font-size: 1.25rem;
    white-space: nowrap;
    th {
      white-space: nowrap;
    }
    select, input {
      height: 2rem;
      min-width: 80px;
    }
  }
  .good {
    color: #009556;
  }
  .normal {
    color: #FFC107;
  }
  .bad {
    color: #F30000;
  }
  .link-tag {
    color: blue;
    &:hover {
      text-decoration: underline;
    }
  }

</style>


// WEBPACK FOOTER //
// Record.vue?6bc7f892